import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classnames from 'classnames';
import { getSpacingClass, getLayoutClass } from '../../../utils/styleUtils';
import styles from './Container.scss';

function Container(_ref) {
  var _classnames;

  var tag = _ref.tag,
      display = _ref.display,
      displayXs = _ref.displayXs,
      displaySm = _ref.displaySm,
      displayLg = _ref.displayLg,
      displayXl = _ref.displayXl,
      margin = _ref.margin,
      marginTop = _ref.marginTop,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginTopXs = _ref.marginTopXs,
      marginLeftXs = _ref.marginLeftXs,
      marginRightXs = _ref.marginRightXs,
      marginBottomXs = _ref.marginBottomXs,
      marginTopSm = _ref.marginTopSm,
      marginLeftSm = _ref.marginLeftSm,
      marginRightSm = _ref.marginRightSm,
      marginBottomSm = _ref.marginBottomSm,
      padding = _ref.padding,
      paddingTop = _ref.paddingTop,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight,
      paddingBottom = _ref.paddingBottom,
      paddingTopXs = _ref.paddingTopXs,
      paddingLeftXs = _ref.paddingLeftXs,
      paddingRightXs = _ref.paddingRightXs,
      paddingBottomXs = _ref.paddingBottomXs,
      paddingTopSm = _ref.paddingTopSm,
      paddingLeftSm = _ref.paddingLeftSm,
      paddingRightSm = _ref.paddingRightSm,
      paddingBottomSm = _ref.paddingBottomSm,
      textAlign = _ref.textAlign,
      nowrap = _ref.nowrap,
      overflow = _ref.overflow,
      children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["tag", "display", "displayXs", "displaySm", "displayLg", "displayXl", "margin", "marginTop", "marginLeft", "marginRight", "marginBottom", "marginTopXs", "marginLeftXs", "marginRightXs", "marginBottomXs", "marginTopSm", "marginLeftSm", "marginRightSm", "marginBottomSm", "padding", "paddingTop", "paddingLeft", "paddingRight", "paddingBottom", "paddingTopXs", "paddingLeftXs", "paddingRightXs", "paddingBottomXs", "paddingTopSm", "paddingLeftSm", "paddingRightSm", "paddingBottomSm", "textAlign", "nowrap", "overflow", "children", "className"]);

  var ElementTag = tag;

  if (ElementTag === 'div' && display === 'inline') {
    ElementTag = 'span';
  }

  var classes = classnames(className, (_classnames = {}, _defineProperty(_classnames, styles["display--".concat(String(display))], display && display !== 'block'), _defineProperty(_classnames, getLayoutClass('xs', displayXs), displayXs), _defineProperty(_classnames, getLayoutClass('sm', displaySm), displaySm), _defineProperty(_classnames, getLayoutClass('lg', displayLg), displayLg), _defineProperty(_classnames, getLayoutClass('xl', displayXl), displayXl), _defineProperty(_classnames, getSpacingClass('margin', 'top', marginTop || margin), marginTop !== 0 || margin !== 0), _defineProperty(_classnames, getSpacingClass('margin', 'right', marginRight || margin), marginRight !== 0 || margin !== 0), _defineProperty(_classnames, getSpacingClass('margin', 'bottom', marginBottom || margin), marginBottom !== 0 || margin !== 0), _defineProperty(_classnames, getSpacingClass('margin', 'left', marginLeft || margin), marginLeft !== 0 || margin !== 0), _defineProperty(_classnames, getSpacingClass('margin', 'top', marginTopXs, 'xs'), marginTopXs !== null), _defineProperty(_classnames, getSpacingClass('margin', 'right', marginRightXs, 'xs'), marginRightXs !== null), _defineProperty(_classnames, getSpacingClass('margin', 'bottom', marginBottomXs, 'xs'), marginBottomXs !== null), _defineProperty(_classnames, getSpacingClass('margin', 'left', marginLeftXs, 'xs'), marginLeftXs !== null), _defineProperty(_classnames, getSpacingClass('margin', 'top', marginTopSm, 'sm'), marginTopSm !== null), _defineProperty(_classnames, getSpacingClass('margin', 'right', marginRightSm, 'sm'), marginRightSm !== null), _defineProperty(_classnames, getSpacingClass('margin', 'bottom', marginBottomSm, 'sm'), marginBottomSm !== null), _defineProperty(_classnames, getSpacingClass('margin', 'left', marginLeftSm, 'sm'), marginLeftSm !== null), _defineProperty(_classnames, getSpacingClass('padding', 'top', paddingTop || padding), paddingTop !== 0 || padding !== 0), _defineProperty(_classnames, getSpacingClass('padding', 'right', paddingRight || padding), paddingRight !== 0 || padding !== 0), _defineProperty(_classnames, getSpacingClass('padding', 'bottom', paddingBottom || padding), paddingBottom !== 0 || padding !== 0), _defineProperty(_classnames, getSpacingClass('padding', 'left', paddingLeft || padding), paddingLeft !== 0 || padding !== 0), _defineProperty(_classnames, getSpacingClass('padding', 'top', paddingTopXs, 'xs'), paddingTopXs !== null), _defineProperty(_classnames, getSpacingClass('padding', 'right', paddingRightXs, 'xs'), paddingRightXs !== null), _defineProperty(_classnames, getSpacingClass('padding', 'bottom', paddingBottomXs, 'xs'), paddingBottomXs !== null), _defineProperty(_classnames, getSpacingClass('padding', 'left', paddingLeftXs, 'xs'), paddingLeftXs !== null), _defineProperty(_classnames, getSpacingClass('padding', 'top', paddingTopSm, 'sm'), paddingTopSm !== null), _defineProperty(_classnames, getSpacingClass('padding', 'right', paddingRightSm, 'sm'), paddingRightSm !== null), _defineProperty(_classnames, getSpacingClass('padding', 'bottom', paddingBottomSm, 'sm'), paddingBottomSm !== null), _defineProperty(_classnames, getSpacingClass('padding', 'left', paddingLeftSm, 'sm'), paddingLeftSm !== null), _defineProperty(_classnames, styles["text-align--".concat(String(textAlign))], textAlign), _defineProperty(_classnames, styles["overflow--".concat(String(overflow))], overflow), _defineProperty(_classnames, styles.nowrap, nowrap), _classnames)); // $FlowFixMe: complaining about otherProps spreading

  var commonProps = _objectSpread({
    children: children,
    className: classes
  }, otherProps);

  return /*#__PURE__*/React.createElement(ElementTag, commonProps);
}

Container.defaultProps = {
  tag: 'div',
  display: null,
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginTopXs: null,
  marginLeftXs: null,
  marginRightXs: null,
  marginBottomXs: null,
  marginTopSm: null,
  marginLeftSm: null,
  marginRightSm: null,
  marginBottomSm: null,
  padding: 0,
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingTopXs: null,
  paddingLeftXs: null,
  paddingRightXs: null,
  paddingBottomXs: null,
  paddingTopSm: null,
  paddingLeftSm: null,
  paddingRightSm: null,
  paddingBottomSm: null,
  textAlign: null,
  nowrap: false,
  overflow: null,
  children: null,
  className: null
};
export default Container;